import { useState, useEffect } from 'react';

export const usePersistentFilter = (key, defaultValue = {}) => {
  const [filters, setFilters] = useState(() => {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(filters));
  }, [key, filters]);

  const resetFilters = (overrides = {}) => setFilters({...defaultValue, ...overrides});

  return [filters, setFilters, resetFilters];
};